import { defineMessages } from 'react-intl-next';
export const messages = defineMessages({
  issueType: {
    id: 'jira-common.ListProjectForms.IssueType',
    defaultMessage: 'Issue type',
    description: 'A button label for a dropdown listing issue types used for forms.'
  },
  requestType: {
    id: 'jira-common.ListProjectForms.RequestType',
    defaultMessage: 'Request type',
    description: 'A button label for a dropdown listing request types used for forms.'
  },
  issueTypeAriaLabel: {
    id: 'jira-common.ListProjectForms.IssueTypeAriaLabel',
    defaultMessage: 'Search issue types',
    description: 'Aria label for issue types picker'
  },
  requestTypeAriaLabel: {
    id: 'jira-common.ListProjectForms.RequestTypeAriaLabel',
    defaultMessage: 'Search request types',
    description: 'Aria label for request types picker'
  }
});